import { useEffect } from "react";
import {
  ButtonV2,
  CardRouded,
  ContainerV2,
  H1,
  InfoV2,
  MyModal,
  P,
  SwitchOptionsV2,
} from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { FormDeliveryResidenceV2 } from "../../Molecules/FormDeliveryResidenceV2";
import { FormDeliveryConcessionaireV2 } from "../../Molecules/FormDeliveryConcessionaireV2";
import { useDeliveryV2 } from "./useDeliveryV2";

const FORM_ID = "form-delivery-v2";

export const DeliveryV2 = () => {
  const {
    stepIndicator,
    modalidade,
    handleModalidadeChange,
    submitResidencia,
    submitConcessionaria,
    isConcessionariaModalOpen,
    handleCancelarConcessionaria,
    handleConfirmarConcessionaria,
  } = useDeliveryV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/domicilio:pageview");
  });

  return (
    <>
      <ContainerV2 nextButton={{ title: "Avançar", form: FORM_ID }}>
        {stepIndicator}
        <div className="pt-8">
          <H1 className="mb-4">Delivery</H1>
          <P className="mb-10">
            Informe o endereço onde o veículo estará disponível para a vistoria.
          </P>
        </div>

        <SwitchOptionsV2
          className="mb-8"
          value={modalidade}
          onChange={handleModalidadeChange}
          options={[
            {
              value: "residencia",
              label: "Em casa",
              icon: {
                active: "/assets/svgs/icon-home-active.svg",
                inactive: "/assets/svgs/icon-home-inactive.svg",
              },
            },
            {
              value: "concessionaria",
              label: "Concessionária",
              icon: {
                active: "/assets/svgs/icon-apartment-active.svg",
                inactive: "/assets/svgs/icon-apartment-inactive.svg",
              },
            },
          ]}
        />

        <CardRouded className="w-full mx-auto">
          {modalidade === "residencia" ? (
            <FormDeliveryResidenceV2
              id={FORM_ID}
              onSubmitForm={submitResidencia}
            />
          ) : (
            <FormDeliveryConcessionaireV2
              id={FORM_ID}
              onSubmitForm={submitConcessionaria}
            />
          )}
        </CardRouded>
      </ContainerV2>

      {modalidade === "residencia" ? (
        <InfoV2 className="max-w-7xl mx-auto" required>
          O local de realização do agendamento é de responsabilidade o cliente.
          Evite vias públicas!
        </InfoV2>
      ) : (
        <InfoV2 className="max-w-7xl mx-auto" required>
          Verifique o{" "}
          <strong>horário de funcionamento da concessionária</strong> antes de
          realizar o agendamento.
        </InfoV2>
      )}

      <MyModal
        isOpen={isConcessionariaModalOpen}
        onRequestClose={handleCancelarConcessionaria}
      >
        <div className="flex w-[400px] flex-col gap-6 p-8">
          <p className="font-['Mulish'] text-base text-[#20332f]">
            Verifique o{" "}
            <strong>horário de funcionamento da concessionária</strong> antes de
            realizar o agendamento.
          </p>

          <div className="flex justify-end gap-4">
            <ButtonV2
              variant="text"
              type="button"
              onClick={handleCancelarConcessionaria}
            >
              Cancelar
            </ButtonV2>
            <ButtonV2 type="button" onClick={handleConfirmarConcessionaria}>
              Avançar
            </ButtonV2>
          </div>
        </div>
      </MyModal>
    </>
  );
};
